import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import NavSpacer from './components/NavSpacer';
import NavDivider from './components/NavDivider';
import NavSingleItem from './components/NavSingleItem';
import NavDropdownItem from './components/NavDropdownItem';
import SidebarNav from './SidebarNav';
import { connect } from 'react-redux';
import RestrictedMenuMessageModal from '../CustomModal/RestrictedMenuMessageModal';
class MobileBottomNav extends Component {
  state = { 
    sidebarOpen: false,
    openRestrictedMenuMessage: false
  };
  // constructor(props) {
  //   super(props);
  // }
  render() {
    const { sidebarOpen, openRestrictedMenuMessage } = this.state;
    const { selectedProperty, isTablet, isSmallerMobile, blockUsersFromUsingApp, history, setShowAfterSignIn, resetData, onLogOut } = this.props;
    console.log('selectedProperty: ', selectedProperty);
    const navbarItems = this.props.navTop;
    const navItems = (items) => {
        return items.map((item, index) => itemType(item, index));
    };    
    const itemType = (item, index) => {      
      if (item.divider) {
        return null;
      } else {
        return <NavSingleItem onLogOut={()=> onLogOut} setShowAfterSignIn={(value)=> setShowAfterSignIn(value)} resetData={()=> resetData()} blockUsersFromUsingApp={blockUsersFromUsingApp} setOpenRestrictedMenuMessage={(value)=> this.setState({openRestrictedMenuMessage: value})} item={item} key={index} history={this.props.history} />;
      }
    };
    
    return (
      <>
        <ul id="main-menu">
          <Navbar >
            {navItems(navbarItems)}
            {navItems(this.props.navBottom)}
            {/* <Navbar.Collapse id="basic-navbar-nav">
              {navItems([this.props.navTop[1], ...this.props.navTop.slice(5)])}
              {navItems(this.props.navBottom)}
            </Navbar.Collapse> */}
          </Navbar>
        </ul>
        {openRestrictedMenuMessage &&
        <RestrictedMenuMessageModal
        open={openRestrictedMenuMessage}
        toggle={()=> this.setState({openRestrictedMenuMessage: false})}
        history={history}
        />}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    stateModal: state.generalReducer.stateModal,
    selectedProperty: state.generalReducer.property,
  };
};

export default connect(mapStateToProps)(MobileBottomNav);
